export default "__VITE_ASSET__1d5f3857__"